module.exports = __webpack_public_path__ + "static/media/house6lg.2addf445.png";